import { User } from "../types/user.types";
import { UserField } from "../constants/userField";
import { mapProjects } from "./project.util";
import { Project } from "../types/project.types";
import { Role } from "../types/role.types";
import {mapRoles} from "./role.util";

export const filteringUser = (showDelete: boolean, searchValue: string, projectId: number, users?: Array<User>, projects?: Array<Project>, roles?: Array<Role>): Array<User> => {
  return users?.filter(user => !showDelete ? !user.isDeleted : true)
    .filter((user) => {
      if (projectId !== 0) {
        return user.projects.map(item => item.projectId).includes(projectId);
      } else {
        return true;
      }
    })
    .filter(user => {
      const mappedProjects = mapProjects(user.projects, projects);
      const mappedRoles = mapRoles(user.projects, roles);
      return user.login.toLowerCase().includes(searchValue.toLowerCase())
        || user.email.toLowerCase().includes(searchValue.toLowerCase())
        || user.fullName.toLowerCase().includes(searchValue.toLowerCase())
        || mappedProjects.some(project => project.name.toLowerCase().includes(searchValue.toLowerCase()))
        || mappedRoles.some(role => role.name.toLowerCase().includes(searchValue.toLowerCase()))
        || user.projects
          .map(project => project.passwordExpirationDate)
          .some(passwordExpirationDate => passwordExpirationDate.toLowerCase().includes(searchValue.toLowerCase()))
        || user.lastActivityDate?.toLowerCase().includes(searchValue.toLowerCase())
    }) || [];
}

export const sortingUsers = (field: UserField, order: "ASC" | "DESC", users?: Array<User>, projects?: Array<Project>, roles?: Array<Role>): Array<User> => {
  return users?.sort((a, b) => {
    let fieldA: string | Date;
    let fieldB: string | Date;
    switch (field) {
      case UserField.projects: {
        const aProject = mapProjects(a.projects, projects);
        const bProject = mapProjects(b.projects, projects);
        fieldA = aProject.map(item => item.name.toLowerCase()).join();
        fieldB = bProject.map(item => item.name.toLowerCase()).join();
        break;
      }
      case UserField.role: {
        const aRoles = mapRoles(a.projects, roles);
        const bRoles = mapProjects(b.projects, roles);
        fieldA = aRoles.map(item => item.name.toLowerCase()).join();
        fieldB = bRoles.map(item => item.name.toLowerCase()).join();
        break;
      }
      case UserField.passwordExpirationDate: {
        fieldA = a.projects.map(project => new Date(project.passwordExpirationDate)).sort((a, b) => a < b ? 1 : -1)[0];
        fieldB = b.projects.map(project => new Date(project.passwordExpirationDate)).sort((a, b) => a < b ? 1 : -1)[0];
        break;
      }
      case UserField.lastActivity: {
        fieldA = a.lastActivityDate ? new Date(a.lastActivityDate) : "";
        fieldB = b.lastActivityDate ? new Date(b.lastActivityDate) : "";
        break;
      }
      case UserField.active: {
        fieldA = a.projects.some(item => item.isActive) ? "1" : "0";
        fieldB = b.projects.some(item => item.isActive) ? "1" : "0";
        break;
      }
      case UserField.deleted: {
        fieldA = a.isDeleted ? "1" : "0";
        fieldB = b.isDeleted ? "1" : "0";
        break;
      }
      default: {
        fieldA = ((a as any)[field] as string).toLowerCase();
        fieldB = ((b as any)[field] as string).toLowerCase();
        break;
      }
    }
    if (order === "DESC") {
      if (fieldA < fieldB) {
        return 1;
      }
      if (fieldA > fieldB) {
        return -1;
      }
      return 0
    } else {
      if (fieldA < fieldB) {
        return -1;
      }
      if (fieldA > fieldB) {
        return 1;
      }
      return 0
    }
  }) || [];
}